// Configuración de la aplicación
export const config = {
  // URL del backend API
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || 'https://api.gogosaporu.com',
  
  // URLs específicas de endpoints
  endpoints: {
    register: '/usuarios/registro',
    login: '/auth/login',
    loginEmail: '/auth/login-email',
    verifyEmail: '/auth/verify-email',
    resendVerification: '/auth/resend-verification',
    forgotPassword: '/auth/forgot-password',
    verifyResetToken: '/auth/verify-reset-token',
    resetPassword: '/auth/reset-password',
    refresh: '/auth/refresh'
  }
};

// Helper para construir URLs completas
export const getApiUrl = (endpoint) => {
  return `${config.apiBaseUrl}${endpoint}`;
};
